
export interface PropertySEOData {
  id: string;
  slug: string;
  title: string;
  shortDescription: string;
  price: number;
  location: string;
  rating: number;
  guests: number;
  mainImage?: string;
}

// Static SEO data for immediate metatag generation
// This should be updated when properties are modified
export const propertiesSEOData: PropertySEOData[] = [
  {
    id: "1",
    slug: "villa-azul-manzanillo",
    title: "Villa Azul Manzanillo",
    shortDescription: "Hermosa villa con vista al mar en Manzanillo",
    price: 2500,
    location: "Manzanillo, Colima",
    rating: 4.8,
    guests: 8,
    mainImage: "https://res.cloudinary.com/dqijdgd4k/image/upload/v1733779989/villa-azul-1_ajyqov.jpg"
  },
  {
    id: "2", 
    slug: "casa-coral-playa",
    title: "Casa Coral Playa",
    shortDescription: "Casa frente al mar con acceso directo a la playa",
    price: 3200,
    location: "Manzanillo, Colima",
    rating: 4.9,
    guests: 6,
    mainImage: "https://res.cloudinary.com/dqijdgd4k/image/upload/v1733779989/casa-coral-1_pmzxrh.jpg"
  },
  {
    id: "3",
    slug: "departamento-centro-manzanillo",
    title: "Departamento Centro Manzanillo",
    shortDescription: "Moderno departamento en el centro de Manzanillo",
    price: 1800,
    location: "Manzanillo, Colima",
    rating: 4.7,
    guests: 4,
    mainImage: "https://res.cloudinary.com/dqijdgd4k/image/upload/v1733779989/depto-centro-1_x8vfmr.jpg"
  }
];

// Helper function to get SEO data by slug
export const getPropertySEODataBySlug = (slug: string): PropertySEOData | null => {
  return propertiesSEOData.find(property => property.slug === slug) || null;
};

// Helper function to generate SEO title
export const generatePropertySEOTitle = (property: PropertySEOData): string => {
  return `${property.title} | Estancia Corta - Alojamiento en ${property.location}`;
};

// Helper function to generate SEO description
export const generatePropertySEODescription = (property: PropertySEOData): string => {
  return `${property.shortDescription}. Capacidad para ${property.guests} huéspedes. Desde $${property.price} MXN por noche. ¡Reserva directo y paga menos!`;
};
